import { render } from "./SelectPackagingModal3.vue?vue&type=template&id=399404c0"
import script from "./SelectPackagingModal3.vue?vue&type=script&lang=js"
export * from "./SelectPackagingModal3.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__